export const messages = {
  en: {
    discountType: {
      search: {
        title: 'Search Conditions',
        applyType: 'Please enter type code',
        typeName: 'Please enter type name'
      },
      list: {
        title: 'Discount Types'
      },
      table: {
        applyType: 'Type Code',
        typeName: 'Type Name',
        typeDesc: 'Type Description',
        createTime: 'Create Time'
      },
      form: {
        applyType: 'Type Code',
        typeName: 'Type Name',
        typeNamePlaceholder: 'Required, please enter type name',
        typeDesc: 'Type Description',
        typeDescPlaceholder: 'Optional, please enter type description'
      },
      validate: {
        applyTypeRequired: 'Type code is required',
        typeNameRequired: 'Type name is required',
        typeNameMaxLength: 'Type name max length is 64',
        typeDescMaxLength: 'Type description max length is 512'
      },
      add: {
        title: 'Add Discount Type',
        success: 'Add success'
      },
      edit: {
        title: 'Edit Discount Type',
        success: 'Edit success'
      },
      delete: {
        title: 'Delete Confirmation',
        confirmText: 'Are you sure to delete this discount type?',
        success: 'Delete success'
      },
      fetchError: 'Failed to fetch discount types'
    },
  },
  zh: {
    discountType: {
      search: {
        title: '查询条件',
        applyType: '请输入类型编码',
        typeName: '请输入类型名称'
      },
      list: {
        title: '优惠类型'
      },
      table: {
        applyType: '类型编码',
        typeName: '类型名称',
        typeDesc: '类型描述',
        createTime: '创建时间'
      },
      form: {
        applyType: '类型编码',
        typeName: '类型名称',
        typeNamePlaceholder: '必填，请填写类型名称',
        typeDesc: '类型描述',
        typeDescPlaceholder: '选填，请填写类型描述'
      },
      validate: {
        applyTypeRequired: '类型编码不能为空',
        typeNameRequired: '类型名称不能为空',
        typeNameMaxLength: '类型名称最大长度64',
        typeDescMaxLength: '类型描述最大长度512'
      },
      add: {
        title: '添加优惠类型',
        success: '添加成功'
      },
      edit: {
        title: '修改优惠类型',
        success: '修改成功'
      },
      delete: {
        title: '删除确认',
        confirmText: '确定删除该优惠类型吗？',
        success: '删除成功'
      },
      fetchError: '获取优惠类型失败'
    },
  }
}